import { render, staticRenderFns } from "./SideBarStyle1.vue?vue&type=template&id=5b8f29ed&scoped=true"
import script from "./SideBarStyle1.vue?vue&type=script&lang=js"
export * from "./SideBarStyle1.vue?vue&type=script&lang=js"
import style0 from "./SideBarStyle1.vue?vue&type=style&index=0&id=5b8f29ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8f29ed",
  null
  
)

export default component.exports